import { Alert, AlertColor, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  severity?: AlertColor;
  children: React.ReactNode;
  onClose?: () => void;
}

const QcsAlert: FC<Props> = ({ className, sx, severity, children, onClose }) => {
  return (
    <Alert
      className={className}
      sx={{ width: 'fit-content', ...sx }}
      severity={severity}
      onClose={onClose}
    >
      {children}
    </Alert>
  );
};

export default QcsAlert;
